import initDropdown from './Dropdown';
import initMultiSelect from './MultiSelect';
import initRangeSlider from './RangeSlider';

export default function() {
    initDropdown();
    initMultiSelect();
    initRangeSlider();
}